import { max } from 'moment';
import styled from "styled-components";
import { ThemeType } from "../../types/Theme";

export const ViewModal = styled.div<{ theme: ThemeType }>`

  .tituloParabens {
    font-weight: bold;
    color: ${({ theme }) => theme.colors.secondary};
    }
    
  .pai-linha{
    display: flex;
    justify-content: center;
    .linha{
    width: 50%;
    display: flex;
    margin-top: 3rem;
    justify-content: center;
    align-items: center;
    position: relative;
    height: 1px;
    background-color: #434343;
  }
}

  .texto {
    padding: 3rem 7rem;
    text-align: justify;
    margin-top: 1rem;
  }

  .BannerModal{
    width: 100%;
  }
  
  .botao{
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 5rem;
  }

  @media (max-width: 550px) {
    .texto {
      padding: 4rem;
    }
  }
`;


export const ViewHome = styled.div<{ paginas: number; theme: ThemeType; demo?: string }>`
  font-family: "Inter", sans-serif;
  position: relative;
  padding: 0rem 10rem;
  padding-bottom: 5rem;

  .tituloHome {
    text-align: left;
    color: ${({ theme }) => theme.colors.secondary};
    margin-bottom: 2rem;
    margin-top: 6rem;
    display: flex;
    justify-content: space-between;
    @media (max-width: 1024px) {
      flex-direction: column;
      align-items: flex-start;
    }
    .subtituloHome{
      color: ${({ theme }) => theme.colors.tertiary};
      font-weight: 400;
      text-align: right;

      @media (max-width: 1024px) {
        text-align: left
      }
    }
  }

  .menus-container{
    .menus{
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 24px 16px;

      @media (max-width: 1024px) {
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 2rem;
      }

      .menu,
      .menuClubeConectado{
        width: 100%;
        height: 10vh;
        background: ${({ theme }) => theme.colors.white};
        border: 1px solid;
        border-color: ${({ theme }) => theme.colors.secondary};
        border-radius: 24px;

        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: row;
        cursor: pointer;
        gap: 2rem;
        @media (max-width: 1024px) {
          flex-direction: column;
          gap: 1rem;
        }

        .image-container {

          svg {
            width: 100%;
            height: 100%;
            object-fit: contain;
            fill: ${({ theme }) =>
    theme.mode == "light"
      ? theme.colors.primary
      : theme.colors.tertiary};
          }
        }

        .nomeMenu{
          .nome{
            color: ${({ theme }) =>
    theme.mode == "light"
      ? theme.colors.primary
      : theme.colors.tertiary};
            font-weight: 700;
          }
        }

        .texto_nova_aula{
          position: absolute;
          top: 15vh;
          background: ${({ theme }) => theme.colors.secondary};
          border-radius: 24px;
          padding: 0.5rem 1.5rem;
          color: ${({ theme }) => theme.colors.white};

          @media (max-width: 1366px) {
            top: 16vh;
          }

          @media (max-width: 1024px) {
            top: 30vh;
          }
        }

        .nomeMenuClubeConectado{
          .nomeClubeConectado{
            color: ${({ theme }) =>
    theme.mode == "light"
      ? theme.colors.primary
      : theme.colors.tertiary};
            font-weight: 700;
          }
        }
      }
    }
  }

  .menu--disabled {
    pointer-events: auto !important;
    position: relative;
  }
  
  .menu--disabled .tooltip-permissao {
    visibility: hidden;
    opacity: 0;
    background: #222;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 6px 12px;
    position: absolute;
    z-index: 1000;
    left: 50%;
    bottom: 110%;
    transform: translateX(-50%);
    font-size: 0.95rem;
    white-space: nowrap;
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
    transition: opacity 0.2s;
    pointer-events: none;
  }
  
  .menu--disabled:hover .tooltip-permissao {
    visibility: visible;
    opacity: 1;
  }

  .destaques {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 16px;
    opacity: ${({ demo }) => demo === "true" ? 0.5 : 1};
    pointer-events: ${({ demo }) => demo === "true" ? "none" : "auto"};
    
    .destaque {
      display: flex;
      min-height: 35rem;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 3rem;
      border-radius: 30px;
      background: ${({ theme }) => theme.colors.white};
      .titulo-destaque{
        color: ${({ theme }) =>
    theme.mode == "light"
      ? theme.colors.primary
      : theme.colors.tertiary};
        font-weight: 700;
        text-align: center;
        span.laranja{
          color: ${({ theme }) => theme.colors.secondary};
        }
      }

      .explicacao{
        color: ${({ theme }) =>
    theme.mode == "light"
      ? theme.colors.primary
      : theme.colors.tertiary};
        font-weight: 400;
        text-align: center;
        max-width: 40rem;
      }

      .btn-saber-mais{
        padding: 0.5rem 4rem;
        cursor: pointer;
        border-radius: 18px;
        background-color: ${({ theme }) => theme.colors.white};
        border: 1px solid;
        border-color: ${({ theme }) => theme.colors.secondary};
        display: flex;
        gap: 0.8rem;
        color: ${(props) => props.theme.colors.secondary};

        svg{
          width: 16px;
          path{
            fill: ${(props) => props.theme.colors.secondary};
          }
        }
      }
    }
  }

  .botaoCompartilhar {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    cursor: pointer;
    background-color: ${({ theme }) => theme.colors.primary};
    border-radius: 40px;
    color: ${({ theme }) => theme.colors.white};
    font-weight: bold;
    margin: 5rem 0 0 0;
    padding: 1rem 0px;
    transform: scale(1);
    transition: 0.3s;
      &:hover {
       transform: scale(1.01) ;
       transition: 0.3s;
      }
  }

  @media (max-width: 1024px) {
    padding: 1rem 5rem;

    > .titulo {
      margin-top: 1rem;
    }

    .tituloHome {
      margin-top: 3rem;
    }

    .destaques{
      grid-template-columns: repeat(2, 1fr);
      .destaque{
        min-height: 40rem;
      }
      .destaque:first-child{
        grid-column: 1 / -1;
        .titulo-destaque,
        .explicacao{
          max-width: 100%;
        }
        .titulo-destaque br{
          display: none;
        }
      }
    }

    @media (max-width: 768px) {
      .destaques {
        .destaque {
          min-height: 40rem;
          padding: 2rem 2rem;
          gap: 2.2rem;
          .titulo-imagem{
            grid-template-columns: 8rem auto;
            img{
              height: 24px;
            }
          }

          .btn-saber-mais{
            padding: 1rem 3rem;

            svg{
              width: 14px;
            }
          }
        }
      }
    }

    @media (max-width: 485px) {
      padding: 1rem 3rem;
      padding-bottom: 15rem;
    }
  }
`;

export const ModalMentoriaContainer = styled.div<{ theme: ThemeType }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5rem 10rem;
  max-width: 100rem;
  @media (max-width: 768px) {
    padding: 5rem;
  }
  .cabecalho-modal{
    display: flex;
    flex-direction: column;
    align-items: center;
      .titulo {
      color: ${({ theme }) => theme.colors.secondary};
      font-weight: 700;
    }
    .subtitulo-criacao {
      color: ${({ theme }) => theme.colors.tertiary};
      padding: 1rem 0 3rem;
      &:nth-child(2) {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        &:after {
          content: "";
          position: absolute;
          bottom: 0;
          border-radius: 100px;
          background-color: ${({ theme }) => theme.colors.elements};
          width: 70%;
          height: 1px;
        }
      }
    }
  }
  .mes{
    padding: 4rem 0 0;
    width: 100%;
    .nome{
      font-weight: bold;
      text-align: left;
    }
    .datas{
      width: 100%;
      .data{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.7rem 0;
        .data-tema{
          flex: 1;
          min-width: 0;
          margin-right: 1rem;
          .tema{
            display: flex;
            text-align: left;
            strong{
              white-space: nowrap;
            }
            span{
              word-break: break-word;
            }
          }
        }
        .dia{
          text-align: left;
        }
        .btn-live-ativo{
          padding: 1rem 5rem;
          cursor: pointer;
          border-radius: 18px;
          background-color: ${({ theme }) => theme.colors.primary};
          color: ${({ theme }) => theme.colors.white};
          font-weight: bold;
        }
        .btn-live{
          padding: 1rem 5rem;
          cursor: pointer;
          border-radius: 18px;
          background-color: ${({ theme }) => theme.colors.elements};
        }
      }
    }
  }
`;

export const ModalCafeConectadoContainer = styled.div<{ theme: ThemeType }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5rem 10rem;
  max-width: 100rem;
  @media (max-width: 768px) {
    padding: 5rem;
  }
  .cabecalho-modal{
    display: flex;
    flex-direction: column;
    align-items: center;
      .titulo {
      color: ${({ theme }) => theme.colors.secondary};
      font-weight: 700;
    }
    .subtitulo-criacao {
      color: ${({ theme }) => theme.colors.tertiary};
      padding: 1rem 0 3rem;
      &:nth-child(2) {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        &:after {
          content: "";
          position: absolute;
          bottom: 0;
          border-radius: 100px;
  .menu--disabled {
    pointer-events: auto !important;
    position: relative;
  }
  .menu--disabled .tooltip-permissao {
    visibility: hidden;
    opacity: 0;
    background: #222;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 6px 12px;
    position: absolute;
    z-index: 1000;
    left: 50%;
    bottom: 110%;
    transform: translateX(-50%);
    font-size: 0.95rem;
    white-space: nowrap;
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
    transition: opacity 0.2s;
    pointer-events: none;
  }
  .menu--disabled:hover .tooltip-permissao {
    visibility: visible;
    opacity: 1;
  }
          background-color: ${({ theme }) => theme.colors.elements};
          width: 70%;
          height: 1px;
        }
      }
    }
  }
  .mes{
    padding: 4rem 0 0;
    width: 100%;
    .nome{
      font-weight: bold;
      text-align: left;
    }
    .data{
      display: grid;
      grid-template-columns: 60% 35%;
      justify-content: space-between;
      align-items: center;
      padding: 0.7rem 0;
      .dia{
        text-align: left;
      }
      .tema-texto{
        text-align: left;
      }
      .btn-live-ativo{
        padding: 1rem 5rem;
        cursor: pointer;
        border-radius: 16px;
        background-color: ${({ theme }) => theme.colors.primary};
        color: ${({ theme }) => theme.colors.white};
        font-weight: bold;
      }
      .btn-live{
        padding: 1rem 5rem;
        cursor: pointer;
        border-radius: 16px;
        background-color: ${({ theme }) => theme.colors.elements};
      }
    }
  }
`;

export const CardsMetricas = styled.div<{ theme: ThemeType }>`
  display: grid;
  grid-template-columns: repeat(4,1fr);
  justify-content: space-between;
  align-items: center;
  gap: 16px;

  @media (max-width: 768px) {
    display: flex;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    gap: 12px;
    padding-bottom: 1rem;
    padding-left: 3rem;
    padding-right: 3rem;
    -ms-overflow-style: none;
  }

  .cardMetricas{
    background: ${({ theme }) => theme.colors.white};
    border-radius: 24px;
    padding: 24px 36px;
    height: 100%;
    justify-content: center;
    display: flex;
    flex-direction: column;
    gap: 10px;

    @media (max-width: 1200px) {
      padding: 16px;
    }

    @media (max-width: 768px) {
      flex: 0 0 70%;
      min-width: 22rem;
      scroll-snap-align: start;
    }

    .tituloCard{
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 8px;
      color: ${({ theme }) => theme.colors.tertiary};

      .iconeCard{
        width: 32px;
        @media (max-width: 1200px) {
          width: 24px;
        }
        svg{
          fill: ${({ theme }) => theme.colors.tertiary};
        }
      }

      @media (max-width: 1200px) {
        gap: 4px;
        .iconeCard{
          width: 24px;
        }
      }

      .nomeCard{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        text-align: left;
      }
    }

    .conteudoCard{
      display: flex;
      flex-direction: column;
      gap: 4px;
      align-items: flex-start;

      .numerosCard{
        display: flex;
        align-items: center;
        gap: 8px;

        .fonteSubtitulo{
          color: ${({ theme }) => theme.colors.tertiary};
        }

        .destaqueUpCard,
        .destaqueDownCard{
          border-radius: 16px;
          font-weight: 700;
          padding: 2px 8px;

          display: flex;
          align-items: center;
          gap: 4px;
          background-image: ${({ theme }) =>
            theme.mode == "light"
            ? "none"
            : "linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))"};
          background-blend-mode: ${({ theme }) =>
            theme.mode == "light"
            ? "normal"
            : "multiply"};
        }

        .destaqueUpCard{
          background-color: ${({ theme }) => theme.colors.dashBgUp};
          color: ${({ theme }) => theme.colors.dashBorderUp};
          border: 0.5px solid ${({ theme }) => theme.colors.dashBorderUp};
        }

        .destaqueDownCard{
          background-color: ${({ theme }) => theme.colors.dashBgDown};
          border: 0.5px solid ${({ theme }) => theme.colors.dashBorderDown};
          color: ${({ theme }) => theme.colors.dashBorderDown};
        }
      }

      .rotuloCard{
        color: ${({ theme }) => theme.colors.tertiary};
      }
    }
  }
`;
